import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "status", "failure"]
  static classes = ["hidden"]
  static values = { copiedMessage: String, copied: Boolean, failed: Boolean }

  disconnect() {
    clearTimeout(this.confirmationTimeout)
  }

  copy(event) {
    event.preventDefault()
    this.write().then((written) => {
      if (written) this._flashConfirmation()
    })
  }

  // Resolves to whether the browser took the text. Once it has, the copied value says so, and the markup can show it.
  // When it turns the text down, the failed value says so, and the failure message shows.
  async write() {
    try {
      await window.navigator.clipboard.writeText(this.sourceTarget.textContent)
      this.failedValue = false
      this.copiedValue = true
      return true
    } catch {
      this.failedValue = true
      return false
    }
  }

  failedValueChanged(failed) {
    this.failureTargets.forEach((failure) => failure.classList.toggle(this.hiddenClass, !failed))
  }

  // A second copy while the first is still showing starts the 2 seconds over.
  _flashConfirmation() {
    clearTimeout(this.confirmationTimeout)
    this._toggleConfirmationClass(true)
    this._announce(this.copiedMessageValue)
    this.confirmationTimeout = setTimeout(() => {
      this._toggleConfirmationClass(false)
      this._announce("")
    }, 2000)
  }

  _toggleConfirmationClass(state) {
    this.element.classList.toggle("show-confirmation", state)
  }

  // An optional live region tells screen readers the copy happened.
  _announce(message) {
    if (this.hasStatusTarget) this.statusTarget.textContent = message
  }
}
